import { WebSocketReceiveError } from './web-socket-receive-error';
import { GenerateUploadUrlRequest } from '../../../image/requests/generate-upload-url-request';
import { exists } from '../../../../functions/exists';
import { MediaUtils } from '../../../../utils/media-utils';
import { DuplicateAsset } from '../../../image/dto/duplicate-asset';
import { Asset } from '../../../image/dto/asset';
import { MediaManagerFileSystem } from '../../../media-manager/shared/media-manager-file-system';

export class WebSocketDuplicateAssetError extends WebSocketReceiveError {
  override payload: DuplicateAsset;

  override onDeserialize() {
    super.onDeserialize();
    this.payload = window?.injector?.Deserialize?.instanceOf(DuplicateAsset, this.payload);
  }

  isFor(req: GenerateUploadUrlRequest): boolean {
    const payloadFileName = this.payload?.duplicateFileName ?? this.payload?.fileName;
    if (exists(payloadFileName)) {
      return payloadFileName?.trim()?.toLowerCase() === req.fileName?.trim()?.toLowerCase();
    }
    const reqFileName = MediaUtils.getFileNameWithoutTimestamp(req?.fileName)?.trim()?.toLowerCase();
    return this.userMessage?.trim()?.toLowerCase()?.includes(reqFileName);
  }

  duplicateAssetMessage(existingAsset: Asset, filesystem: MediaManagerFileSystem | null): string {
    const parentFolderId = existingAsset?.parentFolderId?.trim() || 'ROOT';
    if (!filesystem) {
      return parentFolderId === 'ROOT'
        ? 'File already exists in folder: Root'
        : `File already exists in folder ${parentFolderId}`;
    }
    if (parentFolderId === 'ROOT') {
      return 'File already exists in folder: Root';
    }
    const folderView = filesystem.getFolderView(parentFolderId);
    if (!folderView) {
      return `File already exists in folder ${parentFolderId}`;
    }
    const pathNames = [...folderView.path.map(folder => folder.name), folderView.name].filter((name, index, names) => {
      return exists(name?.trim()) && (index === 0 || name !== names[index - 1]);
    });
    return pathNames.length > 0
      ? `File already exists in folder: Root / ${pathNames.join(' / ')}`
      : `File already exists in folder ${parentFolderId}`;
  }
}
